import BaseValidator from "./Base";

export default class MinLengthValidator extends BaseValidator {
    private minLength: number;

    constructor(name: string, message: string, minLength: number) {
        super(name, message);
        this.minLength = minLength;
    }

    isNotValid(value: any): boolean {
        return value.length < this.minLength;
    }
}
